import React from "react";
import Flex from "@/components/layout/Flex";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CardContentProps } from "../types";

function CardContent({ className, ...props }: CardContentProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Flex
      data-slot="car-content"
      fill
      direction="column"
      justify="start"
      items="center"
      className={cn(className, classes)}
      {...native}
    />
  );
}

CardContent.displayName = "Card.Content";

export default CardContent;
